<template>
  <div>
    <div class="login">
      <div
        style="padding:20px 20px;
    text-align: left;
    display: flex;
    align-items: center;font-weight:bold;"
        @click="goback"
      >
        <mu-icon value="arrow_back"></mu-icon>
        {{this.$route.params.symbolName}}
      </div>
      <dl class="user-title">
        <dd>绑定银行卡</dd>
      </dl>

      <div class="user-form">
        <mu-text-field  full-width type="text" v-model="bankusername" placeholder="请输入持卡人姓名"></mu-text-field>
        <mu-text-field full-width type="text" v-model="bankname" placeholder="请输入银行名称"></mu-text-field>
        <mu-text-field full-width type="text" v-model="banknumber" placeholder="请输入银行卡号"></mu-text-field>
        <mu-text-field full-width type="text" v-model="bankaddress" placeholder="请输入开户行地址"></mu-text-field>
        <div style="width: 100%;align-items: center;
    display: flex;
    text-align: left;"></div>
        <br />
        <mu-button color="primary" :disabled="!canRegister" full-width @click="submit">提交</mu-button>
        <br>
        <div style="color:red;text-align:left;">为了保障您的资金安全,银行卡绑定成功后不可更改,如需修改请联系客服.</div>
      </div>
      
    </div>
  </div>
</template>

<script>
import Api from "@/api";
export default {
  data() {
    return {
        bankusername:"",
        bankname:"",
        banknumber:"",
        bankaddress:"",
        acceptXiyi:true,
    };
  },
  mounted() {
    if(this.$store.state.user.bankinfo){
       this.bankusername = this.$store.state.user.bankinfo.bankusername;
     this.bankaddress = this.$store.state.user.bankinfo.bankaddress;
     this.banknumber = this.$store.state.user.bankinfo.banknumber
     this.banknumber = this.banknumber.substring(0,4)+"***********"+this.banknumber.substring(this.banknumber.length-4,this.banknumber.length)
    
     this.bankname = this.$store.state.user.bankinfo.bankname
    }
  },
  activated() {
     if(this.$store.state.user.bankinfo){
       this.bankusername = this.$store.state.user.bankinfo.bankusername;
     this.bankaddress = this.$store.state.user.bankinfo.bankaddress;
     this.banknumber = this.$store.state.user.bankinfo.banknumber
     this.bankname = this.$store.state.user.bankinfo.bankname
     }
  },

  computed: {
    canRegister() {
      if(this.$store.state.user.bankinfo&&this.$store.state.user.bankinfo.bankusername){
        return false;
      }
      if (this.bankname.length < 4) {
        return false;
      }
      if (this.bankusername.length < 2) {
        return false;
      }
      if (this.banknumber.length < 16) {
        return false;
      }
      if (this.bankaddress.length < 4) {
        return false;
      }
      return this.acceptXiyi;
    }
  },
  methods: {
    toLogin() {
      this.$router.push("/login");
    },
    goback() {
      this.$router.go(-1);
    },

    submit() {
      Api.addbank({
            bankname:this.bankname,
            bankaddress:this.bankaddress,
            bankusername:this.bankusername,
            banknumber:this.banknumber
            }).then(res => {
        this.$indicator.close();
        if (!res.data.hasOwnProperty("error")) {
          this.$toast(res.data.message);
          
        } else {
          this.$toast(res.data.error);
        }
      });
    }
  }
};
</script>

<style scoped>
.user-top {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}
.user-title {
  padding: 40px 20px;
  
  text-align: left;
  font-size: 2rem;
}
.user-form {
  display: flex;
  padding: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.myinput {
  height: 50px;
  width: 80%;
  border: gray;
}
</style>>

</style>


// WEBPACK FOOTER //
// src/pages/AddBank.vue